import { registerOrgOverrideLoaders } from 'lib/orgOverrides';

registerOrgOverrideLoaders({
  dadeschools: () => import(
    /* webpackChunkName: "org-dadeschools" */
    './dadeschools/overrides'
  ),
  enrollokc: () => import(
    /* webpackChunkName: "org-enrollokc" */
    './enrollokc/overrides'
  ),
});
